import gettext from '@sdk/lang/gettext';
import Button from '@sdk/components/ui/buttons/Button';

import { ActionsWrapper } from '@web/conversations/ComposeConversation/ComposeConversationActions/composeConversationActions.styles';
import { UserSearchPicker } from '@web/forms/components/UserSearchPicker/UserSearchPicker';

import { CreatePrivateConversationWrapper } from './createPrivateConversation.styles';
import { useCreatePrivateConversation } from './createPrivateConversation.hooks';
import { CreatePrivateConversationHeader } from './CreatePrivateConversationHeader/CreatePrivateConversationHeader';

export const CreatePrivateConversation = () => {
  const { userOptions, searchQuery, setSearchQuery, cancel, submit } =
    useCreatePrivateConversation();

  return (
    <CreatePrivateConversationWrapper>
      <CreatePrivateConversationHeader />

      <UserSearchPicker
        placeholder={gettext('Start a conversation with...')}
        options={userOptions}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSelect={submit}
      />

      <ActionsWrapper>
        <Button onClick={cancel}>{gettext('Cancel')}</Button>
      </ActionsWrapper>
    </CreatePrivateConversationWrapper>
  );
};
